type Item = {
  label: string;
  slug: string;
};

const items: Item[] = [
  {
    label: "Affinity",
    slug: "affinity",
  },
  {
    label: "CLC - University",
    slug: "nonaffinity",
  },
  {
    label: "CLC - Greek",
    slug: "clcgreek",
  },
  {
    label: "Brandr",
    slug: "brandr",
  },
  {
    label: "Exemplar",
    slug: "exemplar",
  },
  {
    label: "University of Southern California",
    slug: "usc",
  },
  {
    label: "University of Massachusetts",
    slug: "umass",
  },
  {
    label: "Nexus",
    slug: "nexus",
  },
  {
    label: "Indiana University",
    slug: "iu",
  },
  {
    label: "University of Iowa",
    slug: "ui",
  },
  {
    label: "The Ohio State University",
    slug: "tosu",
  },
  {
    label: "Fanatics/Fermata",
    slug: "fanatics",
  },
  {
    label: "University of Notre Dame",
    slug: "und",
  },
  {
    label: "NCAA",
    slug: "ncaa",
  },
  {
    label: "The Ohio State University",
    slug: "osu",
  },
  {
    label: "Athletes Thread",
    slug: "athletesthread",
  },
  {
    label: "DLH",
    slug: "dlh",
  },
  {
    label: "Core81",
    slug: "core81",
  },
];

export function LicenseSelector({
  licensing,
  setLicensing,
}: {
  licensing: string[];
  setLicensing: (licensor: string) => void;
}) {
  return (
    <div>
      {items.map(function (vendor: Item) {
        return (
          <div
            key={vendor.slug}
            className="w-full flex flex-row items-center space-x-4 h-12 p-2"
          >
            <input
              id={vendor.slug}
              name={vendor.slug}
              type="checkbox"
              checked={licensing.includes(vendor.slug)}
              className="focus:ring-dustyrose h-4 w-4 text-dustyrose border-gray-300 rounded"
              onChange={(e) => setLicensing(e.target.id)}
            />
            <p>{vendor.label}</p>
          </div>
        );
      })}
    </div>
  );
}
